import React from "react";
import style from "./index.module.scss";
import ListItem from "../ListItem";
import { useAtomValue } from "jotai";
import {
    selectedIndexAtom,
    SortQuestionList,
    staticsAtom,
    useNavigateQuestion,
    useSort
} from "service/stores/Exercise/Statics";
import { Col, Row } from "antd";

interface TopicListProps {
    setShowList: (showList: boolean) => void;
}

export default function TopicList({ setShowList }: TopicListProps) {
    const { joinPercent } = useAtomValue(staticsAtom);
    const { go } = useNavigateQuestion();
    const selectedIndex = useAtomValue(selectedIndexAtom);
    const questionList = useAtomValue(SortQuestionList);

    const onSort = useSort();

    function onSelect(id: number) {
        go(id);
        setShowList(false);
    }

    return (
        <div className={style.root}>
            <div className={style.header}>
                <div className={style.rate}>参与率{joinPercent}</div>

                <div className={style.tools} onClick={onSort}>
                    <span>共 {questionList.length} 题</span>
                    <button className={style.sort}>正确率</button>
                </div>
            </div>

            <div className={style.list}>
                <div style={{ overflow: "hidden" }}>
                    <Row type="flex" gutter={[20, 20]}>
                        {questionList.map((item, index) => (
                            <Col span={8} key={item.id}>
                                <ListItem
                                    index={index}
                                    data={item}
                                    current={index === selectedIndex}
                                    onSelect={() => onSelect(item.id)}
                                />
                            </Col>
                        ))}
                    </Row>
                </div>
            </div>
        </div>
    );
}
